import React, { useState, useEffect, useRef } from "react";
import Heading from "components/common/Heading/Heading";
import {
  GetInvolvedContainer,
  GetInvolvedBlock,
  GetInvolvedLink,
  GetInvolvedCopy,
  GetInvolvedImage,
  GetInvolvedCta,
} from "./GetInvolved.style";
import ProductColors from "components/common/Colors/ProductColors";

const ProductBlockWithContext = props => {
  const ref = useRef()
  return(<GetInvolvedBlock ref={ref} {...props} />)
};

const GetInvolved = (props) => {
  // eslint-disable-next-line
  const [scrolling, setScrolling] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  
  useEffect(() => {
    const onScroll = e => {
      setScrollTop(e.target.documentElement.scrollTop);
      setScrolling(e.target.documentElement.scrollTop > scrollTop);
      
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);

  const getProductColor = (product) =>{
    const ProductString = String(product)
    switch(true){
      case (ProductString.indexOf('moustache') > -1):
        return ProductColors.Grow
      case (ProductString.indexOf('move') > -1):
        return ProductColors.Move
      case (ProductString.indexOf('host') > -1):
        return ProductColors.Host
      case (ProductString.indexOf('mo-your-own-way') > -1):
        return ProductColors.MYOW
      default:
        return "#fff"
    }
  }
  
  return (
    <GetInvolvedContainer>
      {props.get_involved_cards.map((card)=>{
        return(
          <ProductBlockWithContext color={getProductColor(card.link)} top={scrollTop} key={card.link}>
            <GetInvolvedLink
              class="HP-2020_GetInvolved_OverlayLink"
              href={card.link}
            >
              {card.link}
            </GetInvolvedLink>
            <GetInvolvedCopy>
              <Heading>
                {card.title}
              </Heading>
              <p>
                {card.description}
              </p>
            </GetInvolvedCopy>
            <GetInvolvedCta href={card.link}>
              {card.cta} <img src="/resources/images/icons/arrow.png" width="14" height="9" alt="arrow-icon"/>
            </GetInvolvedCta>
            <GetInvolvedImage
              alt=""
              class="HP-2020_GetInvolved_Image"
              src={card.image.url}
            />
          </ProductBlockWithContext>
        )
      })}
    </GetInvolvedContainer>
  );
};

export default GetInvolved;
